import { Component, computed, input, Signal } from '@angular/core';
import { GcIconComponent, GcLinkComponent } from '@ip-only/front-end-library';
import { FileAsset, GuideVariant } from '../guide-document.entities';

@Component({
  selector: 'app-guide-document-card',
  imports: [GcLinkComponent, GcIconComponent],
  templateUrl: './guide-document-card.component.html',
  styleUrl: './guide-document-card.component.scss',
})
export class GuideDocumentCardComponent {
  variant = input.required<GuideVariant>();
  fileName = input.required<string>();
  title = input.required<string>();
  private readonly basePath = '/assets/guides/guide-documents';

  fileAsset: Signal<FileAsset> = computed(() => this.createFileAsset());

  private createFileAsset(): FileAsset {
    const fileName = this.fileName();
    const title = this.title();
    const variant = this.variant();

    return {
      fileName,
      url: `${this.basePath}/${variant}/${encodeURIComponent(fileName)}`,
      thumbnailUrl: `${this.basePath}/${variant}/${encodeURIComponent(
        fileName.replace(/\.pdf$/i, '.png'),
      )}`,
      title,
    };
  }
}
